module.exports = __webpack_public_path__ + "img/bsp_cat_2.fb34a2ef.jpg";